import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { NgbAccordionModule, NgbCarouselModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { FeatherModule } from 'angular-feather';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { LoginService } from 'src/app/authentication/services/login.service';
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal.component';

@Component({
  selector: 'app-horizontal-navigation',
  standalone: true,
  imports: [NgbDropdownModule, FeatherModule, NgScrollbarModule, CommonModule, NgbAccordionModule, NgbCarouselModule],
  templateUrl: './horizontal-navigation.component.html',
})
export class HorizontalNavigationComponent {
  @Output() toggleSidebar = new EventEmitter<void>();

  public showSearch = false;

  public isCollapsed = false;
  public showMobileMenu = false;


  isAdmin = false;
  user: any;

  constructor(
    private login: LoginService,
    private modalService: NgbModal,
  ) {
    this.userCredentials();
    this.isAdmin = this.login.getIsSuperAdmin();

  }

  async userCredentials() {
    this.user = this.login.getUserInfo();
  }

  logout() {
    this.login.logout();
  }

  resetPassword(size: string) {
    const modalRef = this.modalService.open(ChangePasswordModalComponent, {
      scrollable: true,
      centered: false,
      backdrop: 'static',
      size,
    });
    modalRef.componentInstance.user = this.user;
  }

}
